import { render } from "./PosReceiptSettings.vue?vue&type=template&id=e87af950"
import script from "./PosReceiptSettings.vue?vue&type=script&lang=js"
export * from "./PosReceiptSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__